import { Link } from 'react-router-dom';
import Metadata from '../components/Metadata';

export default function NotFound() {
  return (
    <>
      <Metadata
        title="404 - Siden blev ikke fundet - K. Pheiffer Construction"
        description="Siden du leder efter findes desværre ikke. Gå tilbage til forsiden af K. Pheiffer Construction."
      />

      <section className="min-h-[70vh] flex items-center justify-center bg-white px-4 py-16 sm:py-24">
        <div className="text-center max-w-md mx-auto">
          <div className="h-20 w-20 bg-slate-100 text-slate-800 rounded-full flex items-center justify-center mx-auto mb-6 border border-slate-200">
            <i className="fa-regular fa-triangle-exclamation text-3xl" />
          </div>
          <span className="text-xs font-bold uppercase tracking-widest text-emerald-600">Fejlkode 404</span>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 mt-2">
            Siden blev ikke fundet
          </h1>
          <p className="mt-4 text-slate-500 text-sm sm:text-base leading-relaxed">
            Beklager, men den side du leder efter findes ikke, er blevet flyttet eller er midlertidigt utilgængelig.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded bg-slate-900 hover:bg-slate-800 text-white px-6 py-3 text-sm font-semibold tracking-wide transition-colors"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center rounded border border-slate-200 hover:border-slate-900 text-slate-700 hover:text-slate-900 px-6 py-3 text-sm font-semibold tracking-wide transition-colors"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
